import * as React from "react";
import HistoryList from "./HistoryList";
import Model from "hooks/Model";

function HistoryListScreen() {
  React.useEffect(() => {
    Model.setData("layoutConfig", { withBg: true });
  }, []);
  return <HistoryList />;
}

export default HistoryListScreen;
